import DocumentContainer from './ui/components/Document/DocumentContainer';
import SearchResultContainer from './ui/components/SearchResults/SearchResultContainer';

export default [
  {
    path: '/',
    exact: true,
    component: SearchResultContainer
  },
  {
    path: '/:identifier/(authors/)?',
    exact: true,
    component: DocumentContainer
  }
];



// WEBPACK FOOTER //
// ./src/universal/routes.js